import { defineStore } from "pinia";
import { ref } from 'vue';

export const useCookieBanner = defineStore("cookieOverlay", () => {
  /** State **/
  const is_visible = ref<boolean>(true);

  /** Actions **/
    function show(): void {
    console.log("[cookie-banner.show]: showing the banner");
    is_visible.value = true;
  }
  function hide(): void {
    console.log("[cookie-banner.hide]: hiding the banner");
    localStorage.setItem('cookie-banner-accepted', 'true');
    is_visible.value = false;
  }

  return { is_visible, show, hide }
});
